import { TuiButton } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState } from '@store/auth/auth.state';
import { AsyncPipe } from '@angular/common';
import { RouteNames } from '../../../route-names';

@Component({
  selector: 'app-main-page-navbar',
  imports: [TuiButton, RouterLink, AsyncPipe],
  templateUrl: './main-page-navbar.component.html',
  styleUrl: './main-page-navbar.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageNavbarComponent {
  protected readonly RouteNames = RouteNames;

  isAuthenticated$ = this.store.select(AuthState.isAuthenticated);
  constructor(private readonly store: Store) {}
}
